import { axiosService } from '@services'

import { API } from '../endPoints'

export default async function updateSummaryDashboardActive(dashboardId: string, isActive: boolean) {
  if (!dashboardId) {
    throw new Error('Dashboard ID is required')
  }

  return axiosService({
    method: 'put',
    apiPath: API.ADMIN_DASHBOARD + '/' + dashboardId,
    data: { is_active: isActive },
  })
}
